"use strict";

exports.__esModule = true;
exports.useInterval = useInterval;
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function useInterval(props) {
  var callbackFunction = props.callbackFunction,
    interval = props.interval,
    _props$resetCount = props.resetCount,
    resetCount = _props$resetCount === void 0 ? 0 : _props$resetCount;
  var callbackRef = _react["default"].useRef();
  (0, _react.useEffect)(function () {
    callbackRef.current = callbackFunction;
  }, [callbackFunction]);
  (0, _react.useEffect)(function () {
    if (interval && callbackRef.current) {
      var callback = function callback() {
        callbackRef.current();
      };
      var intervalId = setInterval(callback, interval);
      return function () {
        if (intervalId) {
          clearInterval(intervalId);
          intervalId = null;
        }
      };
    }
  }, [interval, resetCount]);
}